export function MacvlanFormData() {
  this.Scope = 'local';
  this.SelectedNetworkConfig = null;
  this.DatatableState = {
    selectedItems: [],
  };
  this.ParentNetworkCard = '';
}
